export default __webpack_public_path__ + "static/assets/med_pill_round_in_L2_solid_x_01_f_mask.1a847af6.png";